module.exports = __webpack_public_path__ + "img/thumbnail_PallasCat_m_normal.e0fcdcc8.png";